import { Checkbox } from "@/components/ui/checkbox";

export const ClientServicesPicker = ({ services, value, onChange }) => {
  const toggle = (id, on) => onChange(on ? [...value, id] : value.filter((x) => x !== id));
  return (
    <div className="pt-2 border-t border-border" data-testid="client-allowed-services">
      <div className="text-sm font-medium">Serviços visíveis para este cliente</div>
      <div className="text-xs text-muted-foreground mb-2">
        {value.length === 0 ? "Nenhum marcado: o cliente vê todos os serviços." : `${value.length} serviço(s) selecionado(s): o cliente só verá estes.`}
      </div>
      <div className="grid gap-2 max-h-48 overflow-y-auto">
        {services.map((s) => (
          <label key={s.id} className="flex items-center gap-2 text-sm cursor-pointer">
            <Checkbox
              data-testid={`chk-allowed-service-${s.id}`}
              checked={value.includes(s.id)}
              onCheckedChange={(v) => toggle(s.id, !!v)}
            />
            <span>{s.name}</span>
            {s.active === false && <span className="text-xs text-muted-foreground">(inativo)</span>}
          </label>
        ))}
        {services.length === 0 && <div className="text-xs text-muted-foreground">Nenhum serviço cadastrado.</div>}
      </div>
    </div>
  );
};
